export const environment = {
  production: false,
  apiHost: "",
  googleClientId: "398753794436-tkb1alcal75rlsf9fuuqhdesnt0ueofl.apps.googleusercontent.com",
  facebookClientId: "304167974423909",
  googleRecaptchaSiteKey: "6LcruaIZAAAAAF9tivjFYbGSu024J0ZWs2VvE_UI",
  googleAnalyticsId: "UA-166687766-3",
  //Durations in miliseconds
  snackBarMessageDurations: {
    success: 5000,
    error: 5000,
    alert: 5000
  }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
